import { gqlRequest } from './api';

export const cartService = {
  async createOrder({ cartId, manualOrderData, shippingAddress, billingAddress, paymentMethod, userId } = {}) {
    const data = await gqlRequest(`
      mutation CreateOrder(
        $cartId: String,
        $manualOrderData: ManualOrderInput,
        $shippingAddress: OrderAddressInput!,
        $billingAddress: OrderAddressInput!,
        $paymentMethod: PaymentMethodInput!,
        $userId: ID
      ) {
        createOrder(
          cartId: $cartId,
          manualOrderData: $manualOrderData,
          shippingAddress: $shippingAddress,
          billingAddress: $billingAddress,
          paymentMethod: $paymentMethod,
          userId: $userId
        ) {
          id
          startDate
          email
          orderStatus
          totals { subtotal discount tax shipping fee grand }
          items { id sku name price qty totalPrice itemStatus }
          shipping {
            firstname lastname company street complement
            city regionCode countryId postcode
          }
        }
      }
    `, { cartId, manualOrderData, shippingAddress, billingAddress, paymentMethod, userId },
    { requireAuth: true });

    return data.createOrder;
  },

  async addItemsToCart(cartId, items) {
    const data = await gqlRequest(`
      mutation ProductsAddedToCart($ids: [String!]!) {
        productsAddedToCart(ids: $ids)
      }
    `, { ids: items.map(item => item.sku || item.id) },
    { requireAuth: true });

    return data.productsAddedToCart;
  },

  async addProductListToCart(listId, cartId) {
    const data = await gqlRequest(`
      mutation AddMyProductListItemsToCart($id: String!, $cartId: String!) {
        addMyProductListItemsToCart(id: $id, cartId: $cartId)
      }
    `, { id: listId, cartId },
    { requireAuth: true });

    return data.addMyProductListItemsToCart;
  },

  async readInvoice(orderId) {
    const data = await gqlRequest(`
      mutation ReadInvoice($orderId: ID!) {
        readInvoice(orderId: $orderId) {
          id
          invoiceNumber
          customerId
          invoiceDate
          dueDate
          amount
          amountDue
          status
          description
          poNumber
        }
      }
    `, { orderId },
    { requireAuth: true });

    return data.readInvoice;
  }
};
